import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
    wrapper: {
        height: "calc(100% - 6px)",
        width: "100%",
        display: "flex",
        gap: 12,
    },
    side: {
        height: "100%",
        width: "50%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    tableContainer: {
        maxWidth: "135px !important",
    },
    tableRow: {
        "&:last-child td, &:last-child th": { border: 0 },
    },
    tableCell: {
        padding: `2px !important`,
        gap: 12,
    },
    tableCellPadding: {
        padding: `2px !important`,
    },
    title: {
        fontSize: "10px !important",
        color: theme.palette.primary.dark,
        textTransform: "uppercase",
    },
    total: {
        fontWeight: "800 !important",
    },
    labelWrapper: {
        display: "flex",
        alignItems: "center",
        gap: 12,
        width: "100%",
    },
    dot: {
        height: 5,
        width: 5,
        borderRadius: "50%",
    },
    noData: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        width: "100%",
    },
    rightSection: {
        flex: 1,
        overflowY: "auto",
        height: "100%",
        width: "50%",
    },
}));

export const theme = {
    tooltip: {
        container: {
            display: "none",
        },
    },
    labels: {
        text: {
            fontSize: 12,
            fontFamily: "Source Sans 3",
            fontWeight: 400,
        },
    },
};
